module.exports = __webpack_public_path__ + "img/SB.5527b107.svg";